<template>
  <div :class="'sitebuilder-element-panel'  + hideControl()">
    <div v-bind:style="{
        'border-radius': radius,
        background: background,
        height : height,
        border : border,
        'box-shadow': boxShadow,
      }"
         :id="this.internal_config.id"

         element="PanelComponent"
         :data-hide-desktop="!this.internal_config.showDesktop"
         :data-hide-mobile="!this.internal_config.showMobile"
         class="panel panel-primary draggable container-fluid ">
      <div class="panel-body container" >
        <component v-for="(element,index) in elements" :is="element.name" :config="element.config"
                   :childs="element.childs" :key="index"
                   :id="element.id" :height_start="index" :preview="preview"></component>
      </div>
    </div>
  </div>
</template>
<script>

	import Model from './Model';
	// import Resources from './Resources.vue';

	import ImageComponent from "../Image/Image.vue";
	import TextComponent from "../Text/Text.vue";
	import BoxComponent from "../Box/Box.vue";
	import ButtonComponent from "../Button/Button.vue";
    import MailingBossFormComponent from "../Forms/MailingBossForm/MailingBossForm";
    import SimpleFormComponent from "../Forms/SimpleForm/SimpleForm";

    import YoutubeVideoComponent from "../YoutubeVideo/Youtube";
	import IframeComponent from "../Iframe/Iframe";

	import {SweetModal} from 'sweet-modal-vue'
    import MenuComponent from "../Menu/Menu";

	export default {
		name: 'PanelElement',
		components: {
          MenuComponent,
			ButtonComponent,
			ImageComponent,
			IframeComponent,
			TextComponent,
			YoutubeVideoComponent,
			BoxComponent,
			MailingBossFormComponent,
            SimpleFormComponent
		},
		props: ['config', 'childs', 'height_start', 'device', 'id', 'preview'],
		data() {
			return Model.data()
		},
		computed: {
			border() {
				return this.internal_config.border;
			},
			height() {
				return this.internal_config.height;
			},
			boxShadow() {
				return this.internal_config.boxShadow;
			},
			radius() {
				return this.internal_config.borderRadius;
			},
			// bg-color bg-image position/bg-size bg-repeat bg-origin
			background() {
				let bg = this.internal_config.backgroundColor;

				if (this.internal_config.backgroundImage !== 'none' && typeof this.internal_config.backgroundImage !== 'undefined') {
					bg += ' url("' + this.internal_config.backgroundImage + '")';
					bg += ' ' + this.internal_config.backgroundPosition;
					bg += ' / ' + this.internal_config.backgroundSize;
					bg += ' ' + this.internal_config.backgroundRepeat;
					bg += ' ' + this.internal_config.backgroundOrigin;
				}

				return bg;
			},
		},
		methods: {


			 hideControl(){
				 var classAdd = '';
				if(!this.internal_config.showMobile){
					classAdd = classAdd + ' hide-on-mobile'
				}

				if(!this.internal_config.showDesktop){
					classAdd = classAdd + ' hide-on-desktop'
				}

				return classAdd;
			 },

			continueDelete() {
				$(this.$el).detach();
				this.$refs.delete.close();
			},

			duplicatePanel() {
				this.$root.$emit('duplicatePanel', this.id);
			},

			deletePanel() {
				this.$refs.delete.open();
			},

			reorderPanel(idx) {

				let id = this.id,
					sibling = idx === 1 ? document.getElementById(id).parentNode.nextSibling : document.getElementById(id).parentNode.previousSibling;

				if (sibling.firstChild === null) {
					return true;
				}

				this.$root.$emit('changeOrderPanel', id, sibling.firstChild.id, idx);

			},
			togglePanel() {
				this.$root.$emit('toggleElement', this);
			},
			showResources() {
				return this.$refs.resourcesData.getValuesData();
			},
			removeSelection() {
				let elements = document.getElementsByClassName('widget-focused');
				[].forEach.call(elements, function (el) {
					el.classList.remove("widget-focused");
				});
				this.$el.classList.add("widget-focused");

				this.$root.$emit('rSidebarEdition', this);
			},
			//change order on html
			changeOrderPanel(elem, idx) {
				let id = elem.$el.id,
					sibling = idx === 1 ? document.getElementById(id).nextSibling : document.getElementById(id).previousSibling;

				if (sibling === null) {
					return true;
				}

				let vm = this;
				let elements = this.$parent.changeOrderElements(vm.id, id, sibling.id, idx);

				vm.elements = {};
				console.log(elements);
				this.$nextTick(function () {
					vm.elements = elements.childs.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));
				})
			},
			getMinHeight: function () {
				let height = 0;
				let elements = this.$el.getElementsByClassName('sitebuilder-element-container');
				[].forEach.call(elements, function (el) {

					if ((el.offsetHeight + el.offsetTop) > height) {
						height = el.offsetHeight + el.offsetTop;
					}
				});

				return height + 10;
			},
			handler: function (e) {
				this.$refs.resourcesData.setMinValuesData('height', this.getMinHeight());
				this.$root.$emit('focusElement', this);
				this.$root.$emit('handlerElement', this);
				e.stopPropagation();
				e.preventDefault();
			},
		},
		mounted() {
			let device, childs, id, config;
			({device, childs, id, config} = this.$props);

			this.internal_config = config;
			this.device = device;
			this.elements = childs.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));
			if (typeof id !== 'undefined') {
				this.id = id;
			}

			Object.keys(this.props).forEach(prop => {
				if (typeof this.internal_config[prop] === 'undefined') {
					this.internal_config[prop] = this.props[prop];
				}
			});

			if(typeof this.$props.config.anchorName !== 'undefined' && this.$props.config.anchorName !== ''){
			  this.internal_config.id = this.$props.config.anchorName;
            }

            this.$root.$emit('applyAnimation', this, 'sitebuilder-element-panel');
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .panel {
    width: 100%;
  }

  .panel-body {
    position: relative;
  }

  .resizable {
    /* overflow: hidden; */
    resize: both
  }

  .draggable {
    /* position: relative; */
    /* z-index: 100 */
  }

  .draggable-handler {
    cursor: pointer
  }

  .dragging {
    cursor: move;
    /* z-index: 200 !important */
  }

  .panel-body {
    height: 100%;
  }

  .v--modal-overlay[data-modal="my_modal_name"] {
    background: transparent;
  }

  .container {
    /*border: 1px dotted gray;*/
  }

  .container-fluid {
    /*border: 1px dotted gray;*/
  }

</style>
